"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisableDefaultGamepadActions = exports.areDefaultGamepadActionsEnabled = void 0;
const react_1 = require("react");
const hookRefs = [];
const areDefaultGamepadActionsEnabled = () => {
    return hookRefs.length === 0;
};
exports.areDefaultGamepadActionsEnabled = areDefaultGamepadActionsEnabled;
/**
 * Disables default Gamepad input when any mounted component passes `disabled` as
 * true with this hook. Hook callbacks and keyboard input are not affected.
 *
 * @param disabled Whether this instance of the hook disables default gamepad actions
 */
function useDisableDefaultGamepadActions(disabled) {
    const idRef = (0, react_1.useRef)(Symbol('id'));
    (0, react_1.useEffect)(() => {
        const idRefCurrent = idRef.current;
        if (disabled && !hookRefs.includes(idRefCurrent)) {
            hookRefs.push(idRefCurrent);
        }
        else if (!disabled) {
            const refIndex = hookRefs.indexOf(idRefCurrent);
            if (refIndex !== -1) {
                hookRefs.splice(refIndex, 1);
            }
        }
        return () => {
            const refIndex = hookRefs.indexOf(idRefCurrent);
            if (refIndex !== -1) {
                hookRefs.splice(refIndex, 1);
            }
        };
    }, [disabled]);
}
exports.useDisableDefaultGamepadActions = useDisableDefaultGamepadActions;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGlzYWJsZURlZmF1bHRHYW1lcGFkQWN0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy91dGlsaXR5L3VzZURpc2FibGVEZWZhdWx0R2FtZXBhZEFjdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELGlDQUEwQztBQUUxQyxNQUFNLFFBQVEsR0FBYSxFQUFFLENBQUM7QUFFdkIsTUFBTSwrQkFBK0IsR0FBRyxHQUFHLEVBQUU7SUFDaEQsT0FBTyxRQUFRLENBQUMsTUFBTSxLQUFLLENBQUMsQ0FBQztBQUNqQyxDQUFDLENBQUM7QUFGVyxRQUFBLCtCQUErQixtQ0FFMUM7QUFFRjs7Ozs7R0FLRztBQUNILFNBQWdCLCtCQUErQixDQUFDLFFBQWlCO0lBQzdELE1BQU0sS0FBSyxHQUFHLElBQUEsY0FBTSxFQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0lBRW5DLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDWCxNQUFNLFlBQVksR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDO1FBQ25DLElBQUksUUFBUSxJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsRUFBRSxDQUFDO1lBQy9DLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7UUFDaEMsQ0FBQzthQUFNLElBQUksQ0FBQyxRQUFRLEVBQUUsQ0FBQztZQUNuQixNQUFNLFFBQVEsR0FBRyxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxDQUFDO1lBRWhELElBQUksUUFBUSxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUM7Z0JBQ2xCLFFBQVEsQ0FBQyxNQUFNLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQyxDQUFDO1lBQ2pDLENBQUM7UUFDTCxDQUFDO1FBRUQsT0FBTyxHQUFHLEVBQUU7WUFDUixNQUFNLFFBQVEsR0FBRyxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxDQUFDO1lBRWhELElBQUksUUFBUSxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUM7Z0JBQ2xCLFFBQVEsQ0FBQyxNQUFNLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQyxDQUFDO1lBQ2pDLENBQUM7UUFDTCxDQUFDLENBQUM7SUFDTixDQUFDLEVBQUUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO0FBQ25CLENBQUM7QUF2QkQsMEVBdUJDIn0=